import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { MessageCircle, MapPin, Instagram } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Footer } from '../components/Footer';

export const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-white">
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Hero Image */}
          <div className="mb-12 max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                loading="lazy" decoding="async" src="https://customer-assets.emergentagent.com/job_pedigree-cats/artifacts/gu48i4of_contato.jpg"
                alt={language === 'pt' ? 'Ocicat - Contato' : 'Ocicat - Contact'}
                className="w-full h-auto object-cover"
              />
            </div>
            <p className="text-xs text-gray-500 mt-2 text-right italic">Foto: Carla Durante</p>
          </div>

          <h1 className="text-4xl sm:text-5xl font-semibold text-brown-600 mb-4">
            {t.contact.title}
          </h1>
          <p className="text-xl text-gray-700 mb-2">{t.contact.subtitle}</p>
          <p className="text-base text-gray-600 mb-12">{t.contact.subsubtitle}</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Location - First */}
            <Card className="hover:shadow-lg transition-shadow border-gray-200">
              <CardHeader>
                <div className="flex items-center justify-center mb-4">
                  <div className="p-3 bg-gray-100 rounded-full">
                    <MapPin className="text-brown-900" size={28} />
                  </div>
                </div>
                <CardTitle className="text-xl text-brown-900">{t.contact.location}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-base text-brown-900">{t.contact.locationText}</p>
              </CardContent>
            </Card>

            {/* WhatsApp */}
            <Card className="hover:shadow-lg transition-shadow border-gray-200">
              <CardHeader>
                <div className="flex items-center justify-center mb-4">
                  <div className="p-3 bg-gray-100 rounded-full">
                    <MessageCircle className="text-brown-900" size={28} />
                  </div>
                </div>
                <CardTitle className="text-xl text-brown-900">{t.contact.whatsapp}</CardTitle>
              </CardHeader>
              <CardContent>
                <a
                  href="https://wa.me/5551998431175"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-5 py-2.5 bg-brown-900 text-white rounded-full hover:bg-brown-800 transition-colors font-medium text-sm"
                >
                  +55 (51) 99843-1175
                </a>
              </CardContent>
            </Card>

            {/* Instagram */}
            <Card className="hover:shadow-lg transition-shadow border-gray-200">
              <CardHeader>
                <div className="flex items-center justify-center mb-4">
                  <div className="p-3 bg-gray-100 rounded-full">
                    <Instagram className="text-brown-900" size={28} />
                  </div>
                </div>
                <CardTitle className="text-xl text-brown-900">{t.contact.instagram}</CardTitle>
              </CardHeader>
              <CardContent>
                <a
                  href="https://instagram.com/ocicat.brasil"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-5 py-2.5 bg-brown-900 text-white rounded-full hover:bg-brown-800 transition-colors font-medium text-sm"
                >
                  @ocicat.brasil
                </a>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
